import { NgModule } from '@angular/core'
import { Routes, RouterModule } from '@angular/router'
import { LayoutComponent } from './layout/layout.component'
import { AuthGuard } from './core/authentication/auth.guard'
import { NotFoundComponent } from './modules/pages/notFound/not-found.component'
import { ServerErrorComponent } from './modules/pages/serverError/server-error.component'
import { LoginComponent } from './modules/pages/login/login.component'
import { ForbiddenComponent } from './modules/pages/forbidden/forbidden.component'

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    component: LayoutComponent,
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },

      {
        path: 'home',
        canActivate: [AuthGuard],
        loadChildren: () => import('./modules/inbox/inbox.module').then((m) => m.InboxModule),
      },
      {
        path: 'deliverables',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./modules/deliverables/deliverables.module').then((m) => m.DeliverablesModule),
      },
      {
        path: 'deliverables-individuals',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./modules/deliverables-individuals/deliverables-individuals.module').then(
            (m) => m.DeliverablesIndividualsModule
          ),
      },
      {
        path: 'folder',
        canActivate: [AuthGuard],
        loadChildren: () => import('./modules/folder/folder.module').then((m) => m.FolderModule),
      },
      {
        path: 'legalization-upload',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./modules/legalization-upload/legalization-upload.module').then(
            (m) => m.LegalizationUploadModule
          ),
      },
      {
        path: 'legalization-upload-individuals',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import(
            './modules/legalization-upload-individuals/legalization-upload-individuals.module'
          ).then((m) => m.LegalizationUploadIndividualsModule),
      },
      {
        path: 'legalization-form',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./modules/legalization-form/legalization-form.module').then(
            (m) => m.LegalizationFormModule
          ),
      },
      {
        path: 'inbox-individuals',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./modules/inbox-individuals/inbox-individuals.module').then(
            (m) => m.InboxIndividualsModule
          ),
      },
      { path: '404', component: NotFoundComponent },
      { path: '500', component: ServerErrorComponent },
      { path: '403', component: ForbiddenComponent },
    ],
  },

  { path: 'login', component: LoginComponent },

  // Not found
  { path: '**', redirectTo: 'home' },
]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  // imports: [RouterModule.forRoot(routes, { enableTracing: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
